// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__znDwA","label":"SetPasswdForm_label__5GiI4"};